export let resumeconfig = {
    证件类型: [
        "身份证",
        "护照",
        "军官证",
        "香港身份证",
        "澳门身份证",
        "台湾身份证",
        "台胞证",
        "其他",
      ],

      政治面貌: [
        "中国共产党党员",
        "预备党员",
        "共青团员",
        "群众",
        "无党派民主人士",
        "其他党派",
      ],
      最高学历: [
        "博士研究生",
        "硕士研究生",
        "MPA",
        "MBA",
        "本科",
        "大专",
        "高中",
        "中专",
      ],
      学制: ["统招", "全日制", "在职研究生", "成人教育"],
      英语等级: [
        "未参加",
        "未通过",
        "大学英语四级",
        "大学英语六级",
        "大学生英语专业四级",
        "大学生英语专业八级",
        "雅思",
        "托福",
        "托业",
        "GRE",
      ],
      意向工作地: ["江苏", "山东", "河南", "广东"],
      招聘信息来源: [
        "招聘网站",
        "招聘海报",
        "微信",
        "学校老师推荐",
        "公司员工推荐",
        "其他",
      ],
      专业成绩排名: [
        "前5%",
        "前10%",
        "前20%",
        "前30%",
        "前40%",
        "前50%",
        "其他",
      ],
      社团职务: [
        "系统主席/副主席",
        "社团主席/副主席",
        "部长/副部长",
        "班长/团支书",
        "其他",
      ],
      民族: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "僳僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],
}